import React, { FC } from 'react';
import { TaskType } from 'api/tasks';
import { MilestoneTodo, ExportTodo } from 'components/atoms/icons';
import { ProgressPie } from 'components/atoms/progress-pie';
import { Color } from 'components/colors';

export const StatusTodo: FC<{
  type: TaskType;
  color?: Color;
  forExport?: boolean;
}> = ({ type, color, forExport = false }) => {
  return forExport ? (
    <ExportTodo />
  ) : type === TaskType.Milestone ? (
    <MilestoneTodo color={color} />
  ) : (
    <ProgressPie color={color} />
  );
};
